import { APP_ENVIRONMENT } from "../../config/config";
import { getWebGLProgram } from "../helpers/getWebGLProgram";
import { showError } from "./utils";

export function CreateShader(gl: WebGL2RenderingContext, type: number, source: string) {
    const shader = gl.createShader(type)!;
    gl.shaderSource(shader, source);
    gl.compileShader(shader);

    if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
        const compileError = gl.getShaderInfoLog(shader);
        showError(`Failed to COMPILE shader - ${compileError}`);
        //console.log(source);
        const sourceObj = { s: source };
        console.log(sourceObj);
        gl.deleteShader(shader);

        throw new Error("Error during shader creation");
    }
    {
        return shader;
    }
}

export function LinkShaderProgramVSPS(
    gl: WebGL2RenderingContext,
    shaderVS: WebGLShader,
    shaderPS: WebGLShader,
): WebGLProgram {
    const shaderProgram = getWebGLProgram(gl);
    gl.attachShader(shaderProgram, shaderVS);
    gl.attachShader(shaderProgram, shaderPS);
    gl.linkProgram(shaderProgram);

    if (!gl.getProgramParameter(shaderProgram, gl.LINK_STATUS)) {
        const linkError = gl.getProgramInfoLog(shaderProgram);
        showError(`Failed to LINK shaders - ${linkError}`);
        gl.deleteProgram(shaderProgram);
        throw new Error("Error during shader creation");
    } else {
        return shaderProgram;
    }
}

export function CreateShaderProgramVSPS(gl: WebGL2RenderingContext, shaderSourceVS: string, shaderSourcePS: string) {
    //Compile VS
    const shaderVS = CreateShader(gl, gl.VERTEX_SHADER, shaderSourceVS);

    //Compile PS
    const shaderPS = CreateShader(gl, gl.FRAGMENT_SHADER, shaderSourcePS);

    //Create Shader Program
    const shaderProgram = LinkShaderProgramVSPS(gl, shaderVS, shaderPS);

    gl.detachShader(shaderProgram, shaderVS);
    gl.detachShader(shaderProgram, shaderPS);
    gl.deleteShader(shaderVS);
    gl.deleteShader(shaderPS);

    return shaderProgram;
}

export function CheckGL(gl: WebGL2RenderingContext) {
    if (APP_ENVIRONMENT === "development") {
        const error = gl.getError();
        if (error !== gl.NO_ERROR) {
            showError("WebGL error: " + error);
            return false;
        }
    }
    return true;
}

export class Shader {
    ShaderProgram;

    UniformParametersLocationList;

    constructor(
        gl: WebGL2RenderingContext,
        shaderSourceVS: string,
        shaderSourcePS: string,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        uniformParamsFactory: (gl: WebGL2RenderingContext, program: WebGLProgram) => any,
    ) {
        this.ShaderProgram = CreateShaderProgramVSPS(gl, shaderSourceVS, shaderSourcePS);
        this.UniformParametersLocationList = uniformParamsFactory(gl, this.ShaderProgram);
    }
}

//Transform Feedback
export class ShaderTF {
    ShaderProgram;

    UniformParametersLocationList;

    constructor(
        gl: WebGL2RenderingContext,
        shaderSourceVS: string,
        shaderSourcePS: string,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        uniformParamsFactory: (gl: WebGL2RenderingContext, program: WebGLProgram) => any,
        tfVaryings: string[],
    ) {
        {
            const shaderVS = CreateShader(gl, gl.VERTEX_SHADER, shaderSourceVS);
            const shaderPS = CreateShader(gl, gl.FRAGMENT_SHADER, shaderSourcePS);

            this.ShaderProgram = getWebGLProgram(gl);
            gl.attachShader(this.ShaderProgram, shaderVS);
            gl.attachShader(this.ShaderProgram, shaderPS);

            // Specify the varyings to capture for transform feedback
            gl.transformFeedbackVaryings(this.ShaderProgram, tfVaryings, gl.SEPARATE_ATTRIBS);

            gl.linkProgram(this.ShaderProgram);
            if (!gl.getProgramParameter(this.ShaderProgram, gl.LINK_STATUS)) {
                const linkError = gl.getProgramInfoLog(this.ShaderProgram);
                showError(`Failed to LINK shaders - ${linkError}`);
                gl.deleteProgram(this.ShaderProgram);

                //throw new Error("Failed to link shader");
            }

            gl.detachShader(this.ShaderProgram, shaderVS);
            gl.detachShader(this.ShaderProgram, shaderPS);
            gl.deleteShader(shaderVS);
            gl.deleteShader(shaderPS);
        }
        //this.ShaderProgram = CreateShaderProgramVSPS(gl, shaderSourceVS, shaderSourcePS);
        this.UniformParametersLocationList = uniformParamsFactory(gl, this.ShaderProgram);
    }
}
